import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tab,
  Typography,
} from "@mui/material";
import { infoIcon} from '../../../common/MotifIcons';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { MotifProgressLoader, MotifIcon } from "@ey-xd/motif-react";
import { apiQueryWithToken } from "../../../common/services/apiBaseUrlConfig";
import "./InSights.scss";
import { useNavigate } from "react-router";
import logger from "../../../common/utils/logger";
import SafeHtml from "../../../common/SafeHtml";

export const InSights = ({ sector, getFilterValue }) => {
  const [value, setValue] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(false);
  const [insightsData, setInsightsData] = React.useState([]);
  const navigate = useNavigate();

  React.useEffect(() => {
    setIsLoading(true);
    apiQueryWithToken
      .post(`api/UserInsights`, {
        sectorID: getFilterValue.selectedSector || sector,
        subSectorID: getFilterValue.selectedSubSector || 0,
        areaID: getFilterValue.selectedArea || 0,
        countryID: getFilterValue.selectedCountry || 0,
        regionID: getFilterValue.selectedRegion || 0,
        ccsid: getFilterValue.selectedCCS || 0,
        functionID: getFilterValue.selectedFunction || 0,
        revenueRangeID: getFilterValue.selectedRevenue || 0,
        subSubSectorID:getFilterValue.selectedSubSubSectorId || 0
      
      })
      .then((data) => {
        setInsightsData(data.data);
        setIsLoading(false);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          navigate("/");
        } else {
          logger.error("An error occurred:", error);
          setIsLoading(false);
        }
      });
  }, [getFilterValue, sector]);

  return (
    <>
      {isLoading ? (
        <MotifProgressLoader show variant="default" />
      ) : insightsData?.insights?.length > 0 ? (
        <div className="insight-inner-tabs">
          <TabContext value={value}>
            <TabList
              onChange={(e, newValue) => setValue(newValue)}
              aria-label="lab API tabs example"
              borderBottom={1}
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              {insightsData.insights?.map((item, index) => (
                <Tab label={item.ccsType} value={index} />
              ))}
            </TabList>
            {insightsData.insights?.map((item, index) => (
              <TabPanel value={index} sx={{ paddingX: 0 }}>
                <div className="accordion-wrapper">
                  {item?.eyServices?.map((service, index) => (
                    <Accordion key={`outer_${index}`} className="custom-accordion">
                      <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                        <Typography
                          variant="h6"
                          display="flex"
                          justifyContent="flex-start"
                          fontWeight={600}
                          fontSize={15}
                        >
                          {service.service}
                          {service?.tags.map((x) => {
                            return (
                              <div className="tags">
                                <div className="tag">{x}</div>
                              </div>
                            );
                          })}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails sx={{ textAlign: "left" }}>
                        {service?.kpIs?.length > 0 ? (
                          <>
                            {service?.kpIs?.map((kpi, index) => (
                              <Accordion key={`inner_${index}`} className="custom-accordion">
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                >
                                  <Typography
                                    variant="h6"
                                    display="flex"
                                    justifyContent="flex-start"
                                    fontWeight={600}
                                    fontSize={15}
                                  >
                                    {kpi.name}
                                  </Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ textAlign: "left" }} className="admin-details">
                                  {kpi.descriptions
                                    ?.filter((x) => {
                                      return x.adminApprovalFlag === "T";
                                    })
                                    .map((x) => {
                                      return (
                                        <SafeHtml html={x.text.replace(/\n/g, "<br>")} />
                                      );
                                    })}
                                </AccordionDetails>
                              </Accordion>
                            ))}
                          </>
                        ) : (
                          <p>{service?.description ?? ""}</p>
                        )}
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </div>
              </TabPanel>
            ))}
          </TabContext>
        </div>
      ) : (
        <div className="insight-inner-tabs">No Data Found</div>
      )}
        <div className='warning-msg'> <MotifIcon src={infoIcon} /><div className='text'> Outputs are generated by AI. AI can generate incorrect predictions. Review of all generated content is strongly advised.</div></div>
    </>
  );
};
